import { Injectable, OnInit } from "@angular/core";

@Injectable()
export class WizardProgressService implements OnInit{

    progress: number;
    noOfQuestions: number;
    private progressStep: number;

    ngOnInit() {
        this.reset();
    }

    setWizard(noOfQuestions: number): void {
        this.noOfQuestions = noOfQuestions;
        this.progressStep = Math.round(100 / noOfQuestions);
    }

    setQuestion(questionNo: number): void {
        this.progress = questionNo * this.progressStep;
    }

    reset(): void {
        this.progress = 0;
    }
}